class Env {

    // env are exported from the public/env.js
    constructor() {
        this.env = __ENV_VARIABLES__

        // load all variables in the 
        window.__ENV_VARIABLES__ = this.getAll()
    }

    get(key, def) {
        return process.env[`VUE_APP_${key}`] || this.env[key] || def
    }

    getAll() {
        let a = {};

        Object.keys(this.env).forEach(key => {
            a[key] = this.get(key)
        })

        return a
    }
}

export default new Env